/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './allergy-legend.reducer';

export const AllergyLegendDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const allergyLegendEntity = useAppSelector(state => state.allergyLegend.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="allergyLegendDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.allergyLegend.detail.title">AllergyLegend</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.id">Id</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.active">Active</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="medium">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.medium">Medium</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.medium}</dd>
          <dt>
            <span id="source">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.source">Source</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.source}</dd>
          <dt>
            <span id="sourcetype">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.sourcetype">Sourcetype</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.sourcetype}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.allergyLegend.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{allergyLegendEntity.cursor}</dd>
        </dl>
        <Button tag={Link} to="/allergy-legend" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/allergy-legend/${allergyLegendEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AllergyLegendDetail;
